import React from 'react';
// import crypto from 'crypto';
import ReactClass from 'create-react-class';
import Parse from 'parse';
import {Button, FormGroup, FormControl, ControlLabel, Modal, Form, Alert} from 'react-bootstrap';

export default ReactClass({

    getInitialState() {
        return {
            username: "",
            name: "",
            phone: "",
            showModal: false,
            alert: "",
            password: Math.random().toString(36).slice(-8),
        };
    },

    closeModal(user, info) {
        this.props.close(user, info)
    },

    handleAlertDismiss() {
        this.setState({alert: ""});
    },

    save(event) {
        event.preventDefault();
        let _this = this;

        let skipAliasesWords = ["van", "der", "de", "vd", "the"];
        let skipAliases = this.props.skipAliases + skipAliasesWords;
        let aliases = this.state.name.toLowerCase().split(" ").filter(a => skipAliases.indexOf(a) === -1);

        let user = new Parse.User();
        let UserInfo = Parse.Object.extend("UserInfo");
        let info = new UserInfo();
        info.set("phone", this.state.phone);
        info.set("name", this.state.name);
        info.set("aliases", aliases);
        info.save();

        user.set("username", this.state.username.toLowerCase());
        user.set("email", this.state.username.toLowerCase());
        user.set("info", info);
        user.set("password", this.state.password);
        user.save().then(() => {
            info.set("user", user);
            info.save();
            _this.closeModal(user, info);
            alert("New user created:\nE-mail: " + this.state.username + "\nPassword: " + this.state.password );
            _this.setState({username: "",name:"",phone:"",password: Math.random().toString(36).slice(-8)});
            // Parse.User.requestPasswordReset(this.state.username).then(result => {
            // });
        }).catch(error => {
            _this.setState({alert: error.message});
        });
        return false;
    },

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    },

    render() {
        return (
            <Modal show={this.props.show} onHide={this.closeModal}>
                <Form onSubmit={this.save}>
                    <Modal.Header closeButton>
                        <Modal.Title>New user</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.alert !== "" &&
                        <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                            <h4>Error</h4>
                            <p>{this.state.alert}</p>
                        </Alert>
                        }
                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="name"
                                value={this.state.name}
                                placeholder="Name"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>E-mail address</ControlLabel>
                            <FormControl
                                type="text"
                                name="username"
                                value={this.state.username}
                                placeholder="user@example.com"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>Phone number</ControlLabel>
                            <FormControl
                                type="text"
                                name="phone"
                                value={this.state.phone}
                                placeholder="+31123456789"
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup
                            controlId="formBasicText"
                        >
                            <ControlLabel>Password</ControlLabel>
                            <div>{this.state.password}</div>
                        </FormGroup>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>Cancel</Button>
                        <Button bsStyle="primary" type="submit">Save</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

        );
    },

});


// WEBPACK FOOTER //
// ./src/modalUser.js